/**
 * @function descendingComparator
 * @param {string} a
 * @param {string} b
 * @returns {number}
 */
function descendingComparator(a, b, orderBy) {
	if (b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase()) {
		return -1;
	}
	if (b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase()) {
		return 1;
	}
	return 0;
}

/**
 * @function descendingComparator
 * @param {string} order
 * @param {string} orderBy
 * @param {string} orderBy
 * @returns {number}
 */
function getComparator(order, orderBy) {
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

/**
 * @function descendingComparator
 * @param {array} items
 * @param {function} comparator
 * @returns {array}
 */
function stableSort(items, comparator) {
	const stabilizedThis = items.map((item, index) => [item, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

export { getComparator, stableSort };
